var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00016 1.90841C3.9877 1.90841 1.54562 4.35049 1.54562 7.36296C1.54562 10.3754 3.9877 12.8175 7.00016 12.8175C10.0126 12.8175 12.4547 10.3754 12.4547 7.36296C12.4547 4.35049 10.0126 1.90841 7.00016 1.90841ZM0.333496 7.36296C0.333496 3.68106 3.31826 0.696289 7.00016 0.696289C10.6821 0.696289 13.6668 3.68106 13.6668 7.36296C13.6668 11.0449 10.6821 14.0296 7.00016 14.0296C3.31826 14.0296 0.333496 11.0449 0.333496 7.36296Z",
    fill: "#19A619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0602 4.4165L5.66683 8.80984L3.2735 6.42317L2.3335 7.36317L5.66683 10.6965L11.0002 5.36317L10.0602 4.4165Z",
    fill: "#19A619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.db4ac6b080fcc334f4a701c40df76c24.svg";
export { ForwardRef as ReactComponent };